import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface ConfigState {
	selectedCourses: string[];
	selectedCourse: string;
	showCoursesMultiSelect: boolean;
}

const initialState: ConfigState = {
	selectedCourses: [],
	selectedCourse: "",
	showCoursesMultiSelect: false,
};

const courseSlice = createSlice({
	name: "course",
	initialState,
	reducers: {
		setSelectedCourses(state, action: PayloadAction<string[] | string>) {
			if (Array.isArray(action.payload)) {
				// If payload is array, replace the entire array
				state.selectedCourses = action.payload;
			} else {
				// If payload is string, push to array (avoiding duplicates)
				if (!state.selectedCourses.includes(action.payload)) {
					state.selectedCourses.push(action.payload);
				} else {
					// If course already exists, move it to the end (most recent)
					state.selectedCourses = state.selectedCourses.filter(course => course !== action.payload);
					state.selectedCourses.push(action.payload);
				}
			}
		},
		setSelectedCourse(state, action: PayloadAction<string>) {
			state.selectedCourse = action.payload;
		},

		clearSelectedCourses(state) {
			state.selectedCourses = [];
		},
	},
});

export const { setSelectedCourses, clearSelectedCourses, setSelectedCourse } = courseSlice.actions;

export default courseSlice.reducer;
